// CANONICAL COPY (GH #7115). src/constants/obligations/obl-controller-breach-notification.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-controller-breach-notification',
  title: 'Verify controller breach notification procedure (processor duty)',
  description:
    'Confirm that the processor has a procedure to notify each affected controller of a personal-data breach without undue delay after becoming aware, within the DPA-agreed timer (often 24–48 hours; GDPR Art. 33(2); FSR ISAE 3000 Kontrolmål I.1, I.3). Distinct from `obl-regulatory-incident-notification` which covers the controller-to-supervisory-authority 72-hour timer. The procedure shall cover detection-to-notification workflow, required notification content (nature, categories, approximate numbers, likely consequences, measures taken), sub-processor breach escalation, and the per-controller notification log. Review the controller-notification standard and the notification log.',
  category: 'incidents',
  scfIds: ['SCF-INC-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Controller breach notification procedure is published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
